import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import NavVipEntrance from "@meitu/xdesign-widgets/dist/navVipEntrance";
import { useCurrentTeamIdentity } from "@meitu/xdesign-widgets/dist/teamInfo";
import { IdentityType } from "@meitu/xdesign-widgets/dist/types";
import { getLocalIdentity } from "@meitu/xdesign-identity";
import UserInfo from "../userInfo";
import TeamInfo from "../teamInfo";
import LogoSrc from "@/assets/images/logo.svg";
import { openVipModal, jumpToLogin, getUserInfo } from "@/utils/login";
import {
  useGetCutoutInfo,
  useGetMeidouInfo,
  useGetUserInfo,
} from "@/hooks/useUserHelper";
import { statTrack } from "@/utils/mtstat";
import { useStoreState } from "@/store";
import Logo from "@meitu/xdesign-widgets/dist/logo";

import styles from "./index.module.css";
import IconFont from "@meitu/xdesign-icon-font";
import event from "@/utils/event";
import { UPDATE_USER_INFO } from "@/constants/event";
import { SCENE } from "@/constants";

const MeidouInfo = dynamic(
  () => import("@meitu/xdesign-widgets/dist/meidouInfo"),
  {
    ssr: false,
  }
);

interface IProps {
  isPersonal: boolean;
  onCreate?: () => void;
  isWorkSpace?: boolean;
}

const WebHeader = (props: IProps) => {
  const { isPersonal, onCreate, isWorkSpace = false } = props;
  const userInfo = useGetUserInfo();
  const meidouInfo = useGetMeidouInfo();
  const cutoutInfo = useGetCutoutInfo();
  const currentIdentity = useCurrentTeamIdentity();
  const [headerStyle, setHeaderStyle] = useState<React.CSSProperties>({});
  const isOpenPptCommercialization = useStoreState(
    (state) => state.isOpenPptCommercialization
  );

  const isWidgetsConfigDone = useStoreState(
    (state) => state.isWidgetsConfigDone
  );

  const handleOpenVip = (
    params?: any,
    closeCallback?: () => void,
    payCallback?: () => void
  ) => {
    !isWorkSpace &&
      statTrack("landing_page_click", {
        region: "topnav",
      });
    if (!userInfo?.id) {
      jumpToLogin();
      return;
    }
    openVipModal(params, closeCallback, payCallback);
  };

  const handleScroll = () => {
    const scrollY = window.scrollY;
    setHeaderStyle({
      // 根据滚动位置透明度自动计算
      backgroundColor: `rgba(255, 255, 255, ${
        scrollY / 100 > 0.7 ? 0.7 : scrollY / 100
      })`,
      // 高斯模糊
      backdropFilter: `blur(${scrollY / 100 > 25 ? 25 : scrollY / 100}px)`,
    });
  };

  useEffect(() => {
    getUserInfo();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    event.on(UPDATE_USER_INFO, handleUpdateMeidouInfo);
    return () => {
      event.off(UPDATE_USER_INFO, handleUpdateMeidouInfo);
    };
  }, []);

  const handleUpdateMeidouInfo = () => {
    getUserInfo();
  };

  const handleLogin = () => {
    jumpToLogin();
  };

  return (
    <header className={styles.webHeader} style={headerStyle}>
      <div className={styles.left}>
        {isPersonal || (!isPersonal && isWidgetsConfigDone) ? (
          <Logo
            logoUrl={LogoSrc.src}
            height={30}
            hideLogo={false}
            hideSlogan
            hideCollectTip
            hideName={currentIdentity?.type === IdentityType.ENTERPRISE}
            showGuide={false} // 是否显示引导，默认显示
            target="_self" // 打开首页方式，默认新开窗口，_self/_blank
          />
        ) : null}

        {isWidgetsConfigDone ? <TeamInfo /> : null}
      </div>

      <div className={styles.right}>
        {isOpenPptCommercialization !== void 0 ? (
          <NavVipEntrance
            handleClick={() =>
              handleOpenVip({
                entrance: "topnav",
                subscribe_type: "subscription",
              })
            }
            requestParams={
              isOpenPptCommercialization ? { position: "LivePPT" } : {}
            }
            track={statTrack}
            uid={userInfo?.id}
          />
        ) : null}
        {onCreate ? (
          <button className={styles.createBtn} onClick={onCreate}>
            <IconFont
              className={styles.createIcon}
              name="PlusCircleBold"
              fontSize={16}
            />
            从空白创建
          </button>
        ) : null}
        <MeidouInfo
          meidouInfo={meidouInfo}
          project={SCENE}
          onLogin={handleLogin}
          onUpdateMeidouInfo={handleUpdateMeidouInfo}
          autoSendDailyPresentedApi={true}
          vipInfo={{
            is_vip: userInfo?.is_vip || false,
          }}
          onOpenVipModal={(params, closeCallback, payCallback) =>
            handleOpenVip(params, closeCallback, payCallback)
          }
          track={statTrack}
          hideMeiDouRecordsEntrance={!!getLocalIdentity()?.oid}
        />
        <UserInfo
          userInfo={userInfo}
          meidouInfo={meidouInfo}
          cutoutInfo={cutoutInfo}
        />
      </div>
    </header>
  );
};

export default WebHeader;
